import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {  Box, Button,  Container, Typography, Paper, Divider, Grid,} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';

export default function Failure() {
  const location = useLocation();
  const navigate = useNavigate();
  const [paymentData, setPaymentData] = useState(null);


  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const data = Object.fromEntries(params.entries());
    setPaymentData(data);
    
  }, [location.search]);

 useEffect(() => {
    if (!paymentData) return;

   if (paymentData?.status === 'FAILED' || paymentData?.payment_status === 'FAILED') {
     window.dispatchEvent(new Event('refreshNavbar'));
   }


  }, [paymentData]);
  const copyToClipboard = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      alert('Copied to clipboard');
    } catch (e) {
      alert('Copy failed');
    }
  };

  const amount = paymentData?.amount || paymentData?.order_amount || paymentData?.amt || '';
  const txnId = paymentData?.payment_id || paymentData?.txnid || paymentData?.id || paymentData?.order_id || '';
  const statusText = paymentData?.status || paymentData?.payment_status || 'FAILED';
  const isSuccess = statusText?.toLowerCase() === 'success';

  return (
    <Container maxWidth="sm" sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Paper elevation={4} sx={{ p: 4, borderRadius: 3, width: '100%', textAlign: 'center' }}>
        {isSuccess ? (
          <CheckCircleIcon color="success" sx={{ fontSize: 80, mb: 2 }} />
        ) : (
          <CancelIcon color="error" sx={{ fontSize: 80, mb: 2 }} />
        )}

        <Typography variant="h4" fontWeight={600} gutterBottom>
          {isSuccess ? 'Payment Successful' : 'Payment Failed'}
        </Typography>
        <Typography color="text.secondary" gutterBottom>
          {isSuccess
            ? 'Thank you for your payment. Your transaction has been completed.'
            : 'Your payment was not successful. Please try again or contact support.'}
        </Typography>

        <Divider sx={{ my: 3 }} />

        <Grid container spacing={2} justifyContent="center">
          <Grid item xs={6}>
            <Typography variant="body2" color="text.secondary">
              Amount
            </Typography>
            <Typography variant="subtitle1" fontWeight={500}>
              {amount ? `₹${amount}` : '—'}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body2" color="text.secondary">
              Transaction ID
            </Typography>
            <Box display="flex" justifyContent="center" alignItems="center" gap={1}>
              <Typography variant="subtitle1" fontWeight={500} noWrap>
                {txnId || '—'}
              </Typography>
              {txnId && (
                <Button size="small" variant="outlined" onClick={() => copyToClipboard(txnId)}>
                  Copy
                </Button>
              )}
            </Box>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body2" color="text.secondary">
              Status
            </Typography>
            <Typography
              variant="subtitle1"
              fontWeight={500}
              color={isSuccess ? 'success.main' : 'error.main'}
            >
              {statusText}
            </Typography>
          </Grid>
          
        </Grid>

       

        <Box mt={4} display="flex" justifyContent="center" flexWrap="wrap" gap={2}>
          <Button variant="text" onClick={() => navigate(-1)}>Back to Home</Button>
        </Box>

     
    
      </Paper>
    </Container>
  );
}
